import Batch from 'smg/batch';
import * as buttons from 'smg/buttons';
import * as hyejoo from 'smg/customer-api/hyejoo';
import { GetLineItems } from 'smg/customer-api/lineitems';
import { GetProofURLs } from 'smg/proofs';
import { G } from 'smg/querystring';
import * as template from 'smg/template';
import * as carts from '../carts';
import { Relref } from '../hugo';
import * as lineitems from '../lineitems';

declare interface myWindow extends Window {
    readonly cloudFront: string;
    readonly apiRoot: string;
}
declare const window: myWindow;

export default function main() {
    const container = document.querySelector('#quotes-container') as HTMLElement;
    const spinner = document.querySelector('#quotes-spinner') as HTMLElement;
    const searchParent = document.querySelector('#search-parent') as HTMLElement;
    const searchEl = document.querySelector('#quote-search') as HTMLInputElement;

    const currQuery = G().Get('q');
    let q: string = currQuery || '';
    const quoteID = G().Get('id');
    const quoteSentInstanceID = G().Get('instance');

    const showSearch = () => {
        if (currQuery) {
            searchEl.value = currQuery;
        }

        searchParent.classList.remove('d-none');
        spinner.parentElement?.removeChild(spinner);
    };

    if (quoteID) {
        if (quoteID.length === 43) { // key
            q = `key:${quoteID}`;
        } else if (quoteID.length === 38) { // hash
            q = `sha3224:${quoteID}`;
        } else {
            q = `id:${quoteID}`;
        }
    } else if (quoteSentInstanceID) {
        if (quoteSentInstanceID.length === 43) { // key
            q = `quoteSentKey:${quoteSentInstanceID}`;
        } else {
            q = `quoteSentInstanceID:${quoteSentInstanceID}`;
        }
    } else if (!q) {
        showSearch();
        return;
    }

    const b = new Batch();

    b.get<hyejoo.Quotes>('/v2/quotes', {
        params: {
            'sort': 'number asc,created asc',
            'max': 100,
            'data': 'serial,created,quoteLineItems,quoteProofs,cachedTotal,quoteOrders,quoteRequest,key',
            'q': q,
        },
    }).then(async resp => {
        if (!resp.data.quotes.length) {
            if (currQuery) {
                const emptySearchWarning = document.querySelector('#empty-search-warning') as HTMLElement;
                emptySearchWarning.classList.remove('d-none');
            }

            showSearch();
            return;
        }

        const backToSearch = document.querySelector('#back-to-search') as HTMLElement;
        if (!currQuery) {
            backToSearch.parentElement?.removeChild(backToSearch);
        }

        const f = document.createDocumentFragment();

        for (const quote of resp.data.quotes) {
            const el = template.Clone('#quote-template');

            const serial = el.querySelector('.quote-serial') as HTMLElement;
            serial.textContent = String(quote.serial);

            const summary = el.querySelector('.quote-summary') as HTMLElement;
            summary.appendChild(await lineitems.Table(quote.quoteLineItems || []));

            const proofsCount = quote.quoteProofs?.length || 0;

            const proofsContainer = el.querySelector('.quote-proofs-container') as HTMLElement;
            const revisionLink = el.querySelector('.quote-request-revision') as HTMLAnchorElement;
            const proofsParent = el.querySelector('.quote-proofs-parent') as HTMLElement;
            if (quote.quoteProofs?.length) {
                for (const op of quote.quoteProofs) {
                    const p = op.proof;
                    if (!p) {
                        continue;
                    }

                    const urls = GetProofURLs(window.cloudFront, p.file || '', p.path || '');

                    const el = template.Clone('#quote-proof-template').querySelector('.proof-parent') as HTMLElement;

                    const a = el.querySelector('a') as HTMLAnchorElement;
                    a.href = urls.main;
                    a.setAttribute('data-fancybox', quote.id || '');

                    const img = a.querySelector('img') as HTMLImageElement;
                    img.src = urls.main;
                    img.alt = op.name || '';

                    a.appendChild(img);

                    proofsParent.appendChild(el);
                }

                revisionLink.href = `${Relref('/revisions')}?id=${quoteID || quote.key || ''}`;
            }

            const addToCart = el.querySelector('.quote-add-to-cart') as HTMLButtonElement;
            addToCart.addEventListener('click', async () => {
                buttons.Start(addToCart);
                await carts.AddCartItem({ quoteID: quote.key ?? '' }, {
                    promptToCheckout: resp.data.quotes.length !== 1,
                }).then(() => {
                    addToCart.classList.remove('btn-primary', 'btn-success', 'text-white');
                    addToCart.classList.add('btn-outline-success');

                    addToCart.querySelector('i')?.classList.remove('fa-shopping-cart');
                    addToCart.querySelector('i')?.classList.add('fa-check');
                }).finally(() => {
                    buttons.Stop(addToCart);
                    if (resp.data.quotes.length === 1) {
                        window.location.href = Relref('/cart');
                    }
                });
            });

            const cardBody = el.querySelector('.card-body') as HTMLElement;

            if (proofsCount) {
                cardBody.classList.add('row-cols-lg-2');

                revisionLink.href = `${Relref('/revisions')}?id=${quoteID || quote.key || ''}`;

                if (proofsCount > 1) {
                    proofsParent.classList.add('row-cols-lg-2');
                }
            } else {
                proofsContainer.parentElement?.removeChild(proofsContainer);
                revisionLink.parentElement?.removeChild(revisionLink);
            }

            f.appendChild(el);
        }

        spinner.parentElement?.removeChild(spinner);
        container.appendChild(f);
        container.classList.remove('d-none');
    }).catch(err => {
        showSearch();
        throw err;
    });

    void GetLineItems(b);

    void b.Exec();
}